module.exports = __webpack_public_path__ + "static/media/mqtt.30fafb34.jpeg";